"use strict";

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gatsbyLink = require("gatsby-link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.onRenderBody = function (_ref, pluginOptions) {
  var setHeadComponents = _ref.setHeadComponents;

  setHeadComponents([_react2.default.createElement("link", {
    key: "gatsby-plugin-manifest-link",
    rel: "manifest",
    href: (0, _gatsbyLink.withPrefix)("/manifest.json")
  }), _react2.default.createElement("meta", {
    key: "gatsby-plugin-manifest-meta",
    name: "theme-color",
    content: pluginOptions.theme_color
  })]);
};


//////////////////
// WEBPACK FOOTER
// ./~/_gatsby-plugin-manifest@1.0.15@gatsby-plugin-manifest/gatsby-ssr.js
// module id = 258
// module chunks = 0